import { EntityTypeId } from './entity/EntityTypeId.enum'
import type { EntityTypeMeta } from './EntityTypeMeta'


export default function isEntityTypeMetaTerrain(etm: EntityTypeMeta) {
  return etm.id >= EntityTypeId.Plain && etm.id < EntityTypeId.Infantry
}
